import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "detail"
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insureFormInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value) || "-") + " ")])]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保信息")))])]), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      pagination: false,
      "data-source": _vm.data,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return _c("div", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "policyStatus",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text) || "-"))];
      }
    }, {
      key: "action",
      fn: function (text, record, index) {
        return [_c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.openInfo(record, index);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("查看")) + " ")])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.allData.length > 20 ? _c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "font-weight": "700"
    }
  }, [_vm._v(" " + _vm._s(_vm.moreShowBoolen ? _vm.$t("滚动加载更多") : _vm.$t("到底了") + "~") + " ")]) : _vm._e(), _c("insure-info-modal", {
    attrs: {
      visible: _vm.infoVisible,
      status: _vm.insureFormInfo.find(i => i.key == "status").value,
      data: _vm.currentInfo,
      baseInfo: _vm.baseInfo
    },
    on: {
      cancel: function ($event) {
        _vm.infoVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };